var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationProvider", {
    attrs: { rules: _vm.rules, name: _vm.name, vid: _vm.vid },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ failed, errors, valid, touched }) {
          return [
            _c(
              "div",
              {
                staticClass: "form-group",
                style: { marginBottom: _vm.marginBottom },
              },
              [
                _vm.label
                  ? _c("label", {
                      staticClass: "form-control-label",
                      domProps: { innerHTML: _vm._s(_vm.label) },
                    })
                  : _vm._e(),
                !_vm.hideInput
                  ? _c(
                      "div",
                      { staticClass: "input-group input-group-merge" },
                      [
                        _vm.type === "checkbox" && _vm.type === "number"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.iValue,
                                  expression: "iValue",
                                },
                              ],
                              ref: "input",
                              staticClass: "form-control",
                              class: { "is-invalid": failed },
                              attrs: {
                                step: "any",
                                name: _vm.name,
                                placeholder: _vm.placeholder,
                                readonly: _vm.readonly,
                                disabled: _vm.disabled,
                                autocomplete: _vm.autocomplete,
                                accept: _vm.accept,
                                inputmode: "numeric",
                                pattern: "[0-9]*",
                                type: "checkbox",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.iValue)
                                  ? _vm._i(_vm.iValue, null) > -1
                                  : _vm.iValue,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = _vm.iValue,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.iValue = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.iValue = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.iValue = $$c
                                    }
                                  },
                                  _vm.handleChanged,
                                ],
                                focus: _vm.handleFocus,
                              },
                            })
                          : _vm.type === "radio" && _vm.type === "number"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.iValue,
                                  expression: "iValue",
                                },
                              ],
                              ref: "input",
                              staticClass: "form-control",
                              class: { "is-invalid": failed },
                              attrs: {
                                step: "any",
                                name: _vm.name,
                                placeholder: _vm.placeholder,
                                readonly: _vm.readonly,
                                disabled: _vm.disabled,
                                autocomplete: _vm.autocomplete,
                                accept: _vm.accept,
                                inputmode: "numeric",
                                pattern: "[0-9]*",
                                type: "radio",
                              },
                              domProps: { checked: _vm._q(_vm.iValue, null) },
                              on: {
                                change: [
                                  function ($event) {
                                    _vm.iValue = null
                                  },
                                  _vm.handleChanged,
                                ],
                                focus: _vm.handleFocus,
                              },
                            })
                          : _vm.type === "number"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.iValue,
                                  expression: "iValue",
                                },
                              ],
                              ref: "input",
                              staticClass: "form-control",
                              class: { "is-invalid": failed },
                              attrs: {
                                step: "any",
                                name: _vm.name,
                                placeholder: _vm.placeholder,
                                readonly: _vm.readonly,
                                disabled: _vm.disabled,
                                autocomplete: _vm.autocomplete,
                                accept: _vm.accept,
                                inputmode: "numeric",
                                pattern: "[0-9]*",
                                type: _vm.type,
                              },
                              domProps: { value: _vm.iValue },
                              on: {
                                change: _vm.handleChanged,
                                focus: _vm.handleFocus,
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.iValue = $event.target.value
                                },
                              },
                            })
                          : _vm.type === "checkbox"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.iValue,
                                  expression: "iValue",
                                },
                              ],
                              ref: "input",
                              staticClass: "form-control",
                              class: {
                                "is-invalid": failed,
                                "is-valid": valid && touched,
                              },
                              attrs: {
                                name: _vm.name,
                                placeholder: _vm.placeholder,
                                readonly: _vm.readonly,
                                disabled: _vm.disabled,
                                autocomplete: _vm.autocomplete,
                                accept: _vm.accept,
                                type: "checkbox",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.iValue)
                                  ? _vm._i(_vm.iValue, null) > -1
                                  : _vm.iValue,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = _vm.iValue,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.iValue = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.iValue = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.iValue = $$c
                                    }
                                  },
                                  _vm.handleChanged,
                                ],
                                focus: _vm.handleFocus,
                                keyup: _vm.handleKeypress,
                              },
                            })
                          : _vm.type === "radio"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.iValue,
                                  expression: "iValue",
                                },
                              ],
                              ref: "input",
                              staticClass: "form-control",
                              class: {
                                "is-invalid": failed,
                                "is-valid": valid && touched,
                              },
                              attrs: {
                                name: _vm.name,
                                placeholder: _vm.placeholder,
                                readonly: _vm.readonly,
                                disabled: _vm.disabled,
                                autocomplete: _vm.autocomplete,
                                accept: _vm.accept,
                                type: "radio",
                              },
                              domProps: { checked: _vm._q(_vm.iValue, null) },
                              on: {
                                change: [
                                  function ($event) {
                                    _vm.iValue = null
                                  },
                                  _vm.handleChanged,
                                ],
                                focus: _vm.handleFocus,
                                keyup: _vm.handleKeypress,
                              },
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.iValue,
                                  expression: "iValue",
                                },
                              ],
                              ref: "input",
                              staticClass: "form-control",
                              class: {
                                "is-invalid": failed,
                                "is-valid": valid && touched,
                              },
                              attrs: {
                                name: _vm.name,
                                placeholder: _vm.placeholder,
                                readonly: _vm.readonly,
                                disabled: _vm.disabled,
                                autocomplete: _vm.autocomplete,
                                accept: _vm.accept,
                                type: _vm.type,
                              },
                              domProps: { value: _vm.iValue },
                              on: {
                                change: _vm.handleChanged,
                                focus: _vm.handleFocus,
                                keyup: _vm.handleKeypress,
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.iValue = $event.target.value
                                },
                              },
                            }),
                        errors.length
                          ? _c("b-form-invalid-feedback", [
                              _vm._v(_vm._s(errors[0])),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.help
                  ? _c("span", { staticClass: "help-block" }, [
                      _c("small", [_vm._v(_vm._s(_vm.help))]),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }